// extracted by mini-css-extract-plugin
export default {"text":"IFText_text__UPo7q"};